module.exports = "<i class=\"fa fa-spinner myprogress fa-5x\"></i>"